import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import EmployeesTable from '../../components/employees/EmployeesTable';

const Employees = () => (<WrapperSection><GlobalBreadcrumbs /><EmployeesTable /></WrapperSection>);
export default Employees;
